import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Human } from '../../models/data.models';

@Component({
  selector: 'app-human-avatar',
  standalone: true,
  template: `
    <img
      [src]="avatarUrl()"
      [alt]="avatarAlt()"
      class="h-full w-full object-cover"
      loading="lazy"
      decoding="async">
  `,
  styles: [
    ':host { display: block; }',
    'img { display: block; }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HumanAvatarComponent {
  readonly imageUrl = input<string | null | undefined>();
  readonly gender = input<Human['gender'] | null | undefined>();
  readonly name = input<string | null | undefined>();

  readonly avatarUrl = computed(() => {
    const imageUrl = this.imageUrl()?.trim();
    if (imageUrl) return imageUrl;

    if (this.gender() === 'Female') return '/assets/avatars/human-default-female.png';
    if (this.gender() === 'Male') return '/assets/avatars/human-default-male.png';
    return '/assets/avatars/human-default-neutral.png';
  });

  readonly avatarAlt = computed(() => {
    const name = this.name()?.trim();
    return name ? `Photo de profil de ${name}` : 'Photo de profil par défaut';
  });
}
